export enum UserRole {
  Manager = 'manager',
  Commercial = 'commercial',
}
